export default {
  orders: {
    max: {}
  }
}
